"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CraniometricsModePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const templates_1 = require("../../templates");
const bridge_1 = require("@completeanatomy/bridge");
const hooks_1 = require("../../hooks");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const models_1 = require("@completeanatomy/models");
const CraniometricsCarousel_1 = require("../../organisms/CraniometricsCarousel");
const CraniometricsTab_1 = require("../../organisms/CraniometricsTab");
function CraniometricsModePage() {
    const { isMobile } = (0, device_1.usePlatform)();
    const selectedPart = (0, models_1.useSelectedPart)();
    const bridge = (0, bridge_1.useBridge)();
    (0, hooks_1.useSelectInfoBoxTab)(bridge_schema_1.InfoBoxTabType.Craniometrics);
    const onBack = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.exitIsolateMode();
    };
    return ((0, jsx_runtime_1.jsx)(templates_1.ModeTemplate, { mode: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.mode, {
            mode: i18n_1.Strings.infoBox.tabs.craniometrics,
        }), title: selectedPart.name, onBack: onBack, "data-e2e": 'CraniometricsModePage_ModeTemplate', children: !isMobile ? (0, jsx_runtime_1.jsx)(CraniometricsTab_1.CraniometricsTab, { "data-e2e": 'CraniometricsModePage_CraniometricsTab' }) : (0, jsx_runtime_1.jsx)(CraniometricsCarousel_1.CraniometricsCarousel, { "data-e2e": 'CraniometricsModePage_CraniometricsCarousel' }) }));
}
exports.CraniometricsModePage = CraniometricsModePage;
